import { useFlags } from 'launchdarkly-react-client-sdk';
import { FeatureFlags } from '@stigg-types/featureFlags';

export function usePaywallVisibilityControlFeature(packageType: 'Plan' | 'Add-on') {
  const { addonsVisibilityControl: isAddonsVisibilityControlEnabled } = useFlags<FeatureFlags>();

  return packageType === 'Plan' || (packageType === 'Add-on' && isAddonsVisibilityControlEnabled);
}
